// AutoMapper
import { AutoMap } from '@nartc/automapper';

// Dto
import { ContactPersonDto } from 'app/_mapper/contactperson.dto';

export class InsureeDto {
    @AutoMap() bsn: string;
    @AutoMap() initials: string;
    @AutoMap() firstName: string;
    @AutoMap() lastName: string;
    @AutoMap() maidenName: string;
    @AutoMap() streetName: string;
    @AutoMap() houseNumber: string;
    @AutoMap() houseNumberAddition: string;
    @AutoMap() postalCode: string;
    @AutoMap() city: string;
    @AutoMap() countryId: string;
    @AutoMap() phoneNumber: string;
    @AutoMap() phoneNumber2: string;
    @AutoMap() email: string;
    @AutoMap() dateOfBirth: string;
    @AutoMap() gender: string;
    @AutoMap() remarks: string;
    @AutoMap() contactInitiationId: string;
    @AutoMap() contactWithId: string;
    @AutoMap() contactInitiationPhone: string;
    @AutoMap(() => ContactPersonDto) contactPersons: ContactPersonDto[];
}
